import React from 'react';

export default function CodeOfConduct() {
    return (
        <div className="bg-light min-h-screen pt-20">
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
                <h1 className="text-4xl font-bold text-dark mb-10 text-center">Code of Conduct</h1>

                <div className="bg-white p-12 rounded-[2rem] shadow-sm border border-gray-100 text-body">
                    <p className="text-xl leading-relaxed text-center font-medium max-w-3xl mx-auto">
                        At Konnectt, we are committed to maintaining a respectful, transparent, and professional environment for all users. Our platform promotes ethical interactions, trust, and accountability between recruiters and professionals. Any misuse, spam, or unethical behavior may lead to strict action, including account suspension.
                    </p>
                </div>
            </div>
        </div>
    );
}
